module.exports = __webpack_public_path__ + "static/media/icon-marker-maroon.f15044a4.svg";